import React from 'react';
import {   Form,  Typography } from 'antd';
const { Text } = Typography;

const EmployeeManagerDetail = ({ data }) => {

  return (

    <Form >
      <div style={{ display: 'flex' }}>
        <div style={{ marginLeft: '50px' }}>
          <Text style={{ fontWeight: 'bold', fontSize: 18 }}>{data?.userName}</Text>
          <br></br>
          <Text style={{ fontSize: 14 }}>{data?.jobTitle}</Text>
        </div>
        <div style={{ marginLeft: '70px' }}>
          <Text style={{ fontSize: 14 }}>Manager</Text>
          <br></br>
          <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{data?.managerName}</Text>
        </div>
        <div style={{ marginLeft: '70px' }}>
          <Text style={{ fontSize: 14 }}>Department RollUp</Text>
          <br></br>
          <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{data?.departmentRollUp}</Text>
        </div>
        <div style={{ marginLeft: '70px' }}>
          <Text style={{ fontSize: 14 }}>Department</Text>
          <br></br>
          <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{data?.department}</Text>
        </div>
        <div style={{ marginLeft: '70px' }}>
          <Text style={{ fontSize: 14 }}>Location</Text>
          <br></br>
          <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{data?.location}</Text>
        </div>
      </div>



    </Form>
  );
};

export default EmployeeManagerDetail;